import { CapMark } from "@/components/icons";

export function RouteSpinner(): JSX.Element {
  return (
    <div className="grid place-items-center min-h-screen" role="status" aria-live="polite">
      <CapMark className="h-10 w-10 text-primary motion-safe:animate-pulse" />
      <span className="sr-only">Loading</span>
    </div>
  );
}
